export default "__VITE_ASSET__Chj1BZfp__"